import useSearchStore from "@/stores/useSearchStore";

import { Accordion } from "@/components/atoms/Accordion";
import CompanyFilter from "@/components/organisms/filter/CompanyFilter";
import FoundingDateFilter from "@/components/organisms/filter/FoundingDateFilter";
import HeadcountFilter from "@/components/organisms/filter/HeadcountFilter";
import IndustryFilter from "@/components/organisms/filter/industry/IndustryFilter";
import KeywordFilter from "@/components/organisms/filter/KeywordFilter";
import LocationFilter from "@/components/organisms/filter/LocationFilter";
import RevenueFilter from "@/components/organisms/filter/RevenueFilter";
import RevenueGrowthFilter from "@/components/organisms/filter/RevenueGrowthFilter";

export const filterSections = {
  company: "company",
  location: "location",
  headcount: "headcount",
  industry: "industry",
  revenue: "revenue",
  revenueGrowth: "revenueGrowth",
  foundingDate: "foundingDate",
  keyword: "keyword",
};

const FilterSection = () => {
  const defaultValue = useSearchStore((state) => state.filterDropdown);
  const setFilterDropdown = useSearchStore((state) => state.setFilterDropdown);

  return (
    <Accordion type="multiple" defaultValue={defaultValue} onValueChange={setFilterDropdown}>
      <CompanyFilter name={filterSections.company} />

      <IndustryFilter name={filterSections.industry} />

      <LocationFilter name={filterSections.location} />

      <HeadcountFilter name={filterSections.headcount} />

      <KeywordFilter name={filterSections.keyword} />

      <RevenueFilter name={filterSections.revenue} />

      <RevenueGrowthFilter name={filterSections.revenueGrowth} />

      <FoundingDateFilter name={filterSections.foundingDate} />
    </Accordion>
  );
};

export default FilterSection;
